import { defineComponent as C, computed as s, ref as S, resolveComponent as k, createElementBlock as f, openBlock as t, normalizeClass as c, createCommentVNode as l, renderSlot as y, createBlock as m, toDisplayString as v, createElementVNode as $ } from "vue";
import { v as B } from "./vsPreloader-DE9TMol9.mjs";
import { v as N } from "./vsIcon-Cyr63bPF.mjs";
import { _ as h } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const z = C({
  name: "vs-button",
  components: {
    vsPreloader: B,
    vsIcon: N
  },
  props: {
    text: { type: String, default: "" },
    inverted: { type: Boolean, default: !1 },
    buttonType: { type: String, default: "button" },
    isBusy: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    iconName: { type: String, default: "" },
    iconSize: { type: Number, default: 24 },
    iconAfter: { type: Boolean, default: !1 },
    justify: { type: Boolean, default: !1 },
    asyncOnClick: { type: Object, default: () => {
    } },
    badge: { type: Number, default: null },
    badgePosition: { type: String, default: "right" },
    kind: {
      type: String,
      default: "primary"
    }
  },
  emits: ["click", "asyncOnClickResult"],
  setup(e, { emit: n, slots: a }) {
    const p = s(() => e.iconName || e.iconAfter), o = S(!1), b = async (g) => {
      n("click", g);
      try {
        if (e.asyncOnClick) {
          o.value = !0;
          const d = await e.asyncOnClick.process(e.asyncOnClick.params);
          n("asyncOnClickResult", d);
        }
      } catch (d) {
        console.error(d);
      } finally {
        o.value = !1;
      }
    }, i = s(() => a.default && a.default.length > 0), r = s(() => e.disabled || e.isBusy || o.value), u = s(() => e.isBusy || o.value);
    return {
      isRunningCallback: o,
      busyState: u,
      onClick: b,
      isDisabled: r,
      hasDefaultSlot: i,
      emit: n,
      hasIcons: p
    };
  }
}), O = ["type", "disabled"];
function A(e, n, a, p, o, b) {
  const i = k("vs-icon"), r = k("vs-preloader");
  return t(), f("button", {
    type: e.buttonType,
    disabled: e.isDisabled,
    class: c(["ease-in duration-100 transform text-sm focus:outline outline-1 outline-primary outline-offset-2 rounded-xl disabled:opacity-60 py-2 px-4 inline-flex items-center", ` bg-${e.inverted ? "on-" + e.kind : e.kind}
      text-${e.inverted ? e.kind : "on-" + e.kind} ${e.hasIcons ? "" : "justify-center"}
      ${e.isDisabled ? "pointer-events-none" : ""}
      `]),
    onClick: n[0] || (n[0] = (...u) => e.onClick && e.onClick(...u))
  }, [
    e.badge ? (t(), f("div", {
      key: 0,
      class: c(["bg-error text-on-error h-5 w-5 rounded-full absolute -top-2", e.badgePosition === "right" ? "-right-2" : "-left-2"])
    }, v(e.badge), 3)) : l("", !0),
    y(e.$slots, "before"),
    !e.busyState && !e.iconAfter && e.iconName ? (t(), m(i, {
      key: 1,
      name: e.iconName,
      color: e.inverted ? e.kind : "on-" + e.kind,
      size: e.iconSize
    }, null, 8, ["name", "color", "size"])) : l("", !0),
    e.text || e.$slots.default ? (t(), f("div", {
      key: 2,
      class: c(["flex-grow", `${e.iconName ? "pl-2" : ""} ${e.iconAfter ? "pr-2" : ""}`])
    }, [
      y(e.$slots, "default"),
      $("div", null, v(e.text), 1)
    ], 2)) : l("", !0),
    !e.busyState && e.iconAfter ? (t(), m(i, {
      key: 3,
      name: e.iconName,
      color: "on-" + e.kind,
      size: e.iconSize
    }, null, 8, ["name", "color", "size"])) : l("", !0),
    y(e.$slots, "after"),
    e.busyState ? (t(), m(r, {
      key: 4,
      color: `on-${e.kind}`,
      size: 24
    }, null, 8, ["color"])) : l("", !0)
  ], 10, O);
}
const P = /* @__PURE__ */ h(z, [["render", A]]);
export {
  P as v
};
//# sourceMappingURL=vsButton-BlFL21k0.mjs.map
